// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d2h-file-side-diff .d2h-code-line pre {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

.d2h-file-header {
  display: none;
}

.d2h-code-line {
  display: flex;
  flex-direction: row;
  max-width: 100%;
}

.d2h-code-line > span {
  display: inline-flex;
  max-width: 100%;
  white-space: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/DiffViewer.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".d2h-file-side-diff .d2h-code-line pre {\n  white-space: pre-wrap !important;\n  word-wrap: break-word !important;\n  overflow-wrap: break-word !important;\n}\n\n.d2h-file-header {\n  display: none;\n}\n\n.d2h-code-line {\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n}\n\n.d2h-code-line > span {\n  display: inline-flex;\n  max-width: 100%;\n  white-space: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
